'use client';

import { createContext, ReactNode } from 'react';

export const DEFAULT_APP_SIDEBAR_WIDTH = '450px';

export interface AppContextSidebarContextContentProps {
  title?: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
  showCloseButton?: boolean;
}

export interface AppContextSidebarContextProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  content: AppContextSidebarContextContentProps;
  setContent: (content: AppContextSidebarContextContentProps) => void;
  width: string;
  setWidth: (width: string) => void;
}

const initialState: AppContextSidebarContextProps = {
  isOpen: false,
  setIsOpen: () => {},
  content: {},
  setContent: () => {},
  width: DEFAULT_APP_SIDEBAR_WIDTH,
  setWidth: () => {},
};

const AppContextSidebarContext = createContext<AppContextSidebarContextProps>(initialState);

export default AppContextSidebarContext;
